import checkRoles from "@beeldit/user-and-access/auth/services/checkRoles";

const filterConfig = {
  type: 'object',
  properties: {      
      search: {
          type: 'string',
      },
      category_id: {
          "type": "integer",
      },
      producer_id: {}
    }
}
const getFiltersConfig: any = (user: any) => {
    if (checkRoles(user, ['admin'])) {
        filterConfig.properties.producer_id = {
            "type": "integer",
        };
    }
  return filterConfig;
}
export default getFiltersConfig;